import { render, staticRenderFns } from "./score-threshold-info-modal.vue?vue&type=template&id=32e66529"
import script from "./score-threshold-info-modal.vue?vue&type=script&lang=js"
export * from "./score-threshold-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports